module.exports = __webpack_public_path__ + "3bc91eb4f05f1681e8a3b1b57065495c.svg";